import * as React from 'react';
import { Typography, Box, Menu, MenuItem, Button, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import Link from 'components/Link';
import { getColor } from 'utils/theme';

import close from 'images/close.svg';

const ExpandIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
			<path 
				d="M297.4 470.6C309.9 483.1 330.2 483.1 342.7 470.6L534.7 278.6C547.2 266.1 547.2 245.8 534.7 233.3C522.2 220.8 501.9 220.8 489.4 233.3L320 402.7L150.6 233.4C138.1 220.9 117.8 220.9 105.3 233.4C92.8 245.9 92.8 266.2 105.3 278.7L297.3 470.7z"
				fill="#ffffff"
			/>
		</svg>
	)
}

const Dropdown = ({open, links, anchor, onClose, anchorOrigin, transformOrigin}) => {
	const overrides = {
		'& .MuiPopover-paper': {
			background: getColor('green'),
			color: getColor('neutral', 100),
			boxShadow: 'none',
			borderRadius: 0,
			border: 'none',
			top: '0px !important',
			left: '0px !important',
			width: '100%',
			maxWidth: '100%',
		},
		'& .MuiMenu-list': {
			padding: '0',
			margin: '0',
			'a': {
				textDecoration: 'none',
			}
		},
	};

	const menuStyle = {
		display: 'block',
		padding: '90px 50px 20px 50px',
	}

	const buttonStyle = {
		position: 'absolute',
		right: '38px',
		top: '38px',
	}

	const menuItemStyle = {
		marginBottom: '16px',
	}

	return (
		<Menu sx={overrides} open={open} onClose={onClose} anchorOrigin={anchorOrigin} transformOrigin={transformOrigin}>
			<Button variant="silent" onClick={onClose} sx={buttonStyle}><img src={close} alt="Close menu"/></Button>
			<Box sx={menuStyle} className="mobileNav">
				{links.map((item, index) => {
					let submenuLinks = [];
					if (item.hasOwnProperty("children")) submenuLinks = item.children
					if (!JSON.parse(item.visible)) return null;
					return (
						<>
						{submenuLinks.length === 0 &&
							<MenuItem key={index} sx={menuItemStyle}><Link href={item.href} activeClassName="active" onClick={onClose}><Typography variant="header">{item.text}</Typography></Link></MenuItem>
						}
						{submenuLinks.length > 0 &&
							<MenuItem
									key={`menu_${index}`} sx={menuItemStyle}>
								<Accordion 
									variant='offcanvas'
								>
									<AccordionSummary expandIcon={<ExpandIcon />}>
										<Typography variant="header">{item.text}</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<MenuItem sx={menuItemStyle}><Link href={item.href} activeClassName="active" onClick={onClose}><Typography variant="dropdown-menu">{item.text}</Typography></Link></MenuItem>
										{submenuLinks.map((subLink, subIndex) => {
											return (
												<MenuItem key={`menu_${index}_sub_item_${subIndex}`} sx={menuItemStyle}><Link href={subLink.href} activeClassName="active" onClick={onClose}><Typography variant="dropdown-menu">{subLink.text}</Typography></Link></MenuItem>
											)
										})}
									</AccordionDetails>
								</Accordion>
							</MenuItem>
						}
						</>
					)
				})}
			</Box>
		</Menu>
	)
}

export default Dropdown;